import { Box, Heading } from '@hover/blueprint';
import React from 'react';

import {
  useDetectUserSessionQuery,
  useProfileQuery,
} from 'src/shared/graphql/generated';

const Profile = () => {
  useDetectUserSessionQuery();
  const { data: profileData } = useProfileQuery();

  return (
    <Box>
      <Heading size={700}>{profileData?.profile.user.name}</Heading>
    </Box>
  );
};

export { Profile };
